export default "__VITE_ASSET__1c63ebde__"